import $ from "jquery";
import moment, { Moment } from "moment";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { AbsenceSalarieDto } from "../../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { AbsenceSalarieRangeDto } from "../../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieRangeDto";
import { CommandeEnregistrementAbsenceDto } from "../../../../dto/GenApi.iNotPaie.Dto/CommandeEnregistrementAbsenceDto";
import { EtatAbsencesEnum } from "../../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { JourFerieDto } from "../../../../dto/GenApi.iNotPaie.Dto/JourFerieDto";
import { ParametreDto } from "../../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { TypeJournee } from "../../../../dto/GenApi.iNotPaie.Dto/TypeJournee";
import { ModeOuvertureAbsence } from "../../../../shared/models/AbsenceEnum";
import { NotificationServiceInstance } from "../../../../shared/services/notification.service";
import { EventBus } from "../../../Controls/EventBus";
import EventConstants, { RoleConstants } from "../../../Controls/EventConstants";
import { ParametresInstance } from "../../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";

interface dayObject {
    nameDay: number;
    valueDay: number;
    end: boolean;
}

interface tupleDateClass {
    m: number,
    n: number,
    nextMonth: boolean,
    d: Date,
    classe: string
}

@Component({
    components: {
        DatePickerModal: require("../../../calendrier/datePickerModal/datePickerModal.vue.html")
    }
})
export default class ModalAjouterAbsence extends Vue {
    public rowNumber: number[] = [0, 1, 2, 3, 4, 5, 6];
    public ligneNumber: number[] = [0, 1, 2, 3, 4, 5];
    public monthNames: string[] = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre", "Janvier"];
    public dayNames: string[] = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
    public listeCodesAbsencesEligiblesCrpcen = ["JCMAT", "JCPAT", "JMALA", "JMALS"];
    public listDays: dayObject[] = [];
    public currentDate: Date = new Date();
    public currentMonth: number = new Date().getUTCMonth();
    public currentYear: number = new Date().getUTCFullYear();
    public currentFilterMonth: number = new Date().getUTCMonth();
    public currentFilterYear: number = new Date().getUTCFullYear();
    public nextMonthDate: Date = new Date();
    public nextMonthMonth: number = new Date().getUTCMonth();
    public nextMonthYear: number = new Date().getUTCFullYear();
    public dateDebut?: string = undefined;
    public dateDernierTravaille?: string = undefined;
    public dateRepriseReelle?: string = undefined;
    public subrogationDebut?: string = undefined;
    public subrogationFin?: string = undefined;
    public dateFin?: string = undefined;
    public codeTypeAbsence?: string = "";
    public libelleBulletin?: string = "";
    public codeMotifReprises?: string = "";
    public debutMatinAprem?: string = undefined;
    public nombreHeures?: number = undefined;
    public nombreJours?: number = 0;
    public nombreMois?: number = 0;
    public finMatinAprem?: string = undefined;
    public idSalarie?: number = undefined;
    public idConge?: number = undefined;
    public dateChargeePremierMoisCalendrier?: Date = undefined;
    public listeTypeAbsences: ParametreDto[] = [];
    public listeMotifReprises: ParametreDto[] = [];
    public subrogation: boolean = false;
    public envoyerEMailSalarie: boolean = false;
    public dureeLibelleHeuresParDefaut: string = "Nombre d'heures";
    public dureeLibelleJoursParDefaut: string = "Nombre de jours";
    public dureeLibelleMoisParDefaut: string = "Nombre de mois";
    public dureeLibelleHeures?: string;
    public dureeLibelleJours?: string;
    public dureeLibelleMois?: string;
    public isModeHeures = false;
    public isModeJours = false;
    public isModeMois = false;
    public isReadOnlyHeures = false;
    public isReadOnlyJours = false;
    public isReadOnlyMois = false;
    public enableDateDernierJourTravaille = false;
    public oneAbsence?: AbsenceSalarieDto = undefined;
    public idSelected?: number = 0;
    public isLoading = false;
    public enableDebutMatinApremM = true;
    public enableDebutMatinApremA = true;
    public enableFinMatinApremM = true;
    public enableFinMatinApremA = true;
    public enableInputDebutMatinAprem = true;
    public enableInputFinMatinAprem = true;
    public enableSelectDebutMatinAprem = true;
    public enableSelectFinMatinAprem = true;
    public minEndDate: string = new Date().toLocaleDateString();
    public isUpdate = false;
    public isUpdating = false;
    public absencePeriode: AbsenceSalarieDto[] = [];
    public couleur?: string = undefined;
    public currentId = 0;
    public errorMessage: string[] = [];
    public isModified = false;
    public modifEnCours = false;
    public previewDetails?: string = "";
    public typeConges?: string = undefined;
    public nouvelleSaisie = true;
    public listTypeConge: AbsenceSalarieDto[] = [];
    public backgroundColorGrey = "#cccccc";
    public listeJourFerie: JourFerieDto[] = [];
    public paieEnable = false;
    public getOldclass = "";
    public modeOuvertureAbsence: ModeOuvertureAbsence = ModeOuvertureAbsence.AbsenceSalarieParSalarie;
    public hideCRPCEN: boolean = false;
    public enableCRPCEN: boolean = false;
    public enableMotifReprise: boolean = false;
    public tableauDesClassesCongesPoses: tupleDateClass[] = [];
    public tableauDesClassesSelection: tupleDateClass[] = [];
    public etatAbsence?: EtatAbsencesEnum;
    public absenceSalarieRangeDto: AbsenceSalarieRangeDto = {
        dateDebut: new Date(), dateFin: new Date()
    };

    public isSaving = false;
    public titreAbsence: string = "";

    @Prop({ default: false })
    public isActionSalarie: boolean = false;

    public mounted(): void {
        EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
            this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
            this.setData();
            this.reset();
        });
        EventBus.$on(EventConstants.ALL_LISTES_LOADED, () => {
            this.setData();
        });
        this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
        if (ParametresInstance.societeCourante != null) {
            this.setData();
            this.reset();
        }
    }

    private sortListeTypeAlpha(data: ParametreDto[]): ParametreDto[] {
        return data.sort((a, b) => a.Libelle ? a.Libelle?.localeCompare(b.Libelle ? b.Libelle : "") : 0);
    }

    private setData() {
        // Tri Alphabetique Liste Types Absences
        this.listeTypeAbsences = this.sortListeTypeAlpha(ParametresInstance.listeTypeAbsences);
        this.listeMotifReprises = ParametresInstance.listeMotifReprises;
    }

    private getListTypeConges(): void {
        this.listTypeConge = [];

        if (this.absencePeriode.length > 0) {
            const uniq = {};
            this.listTypeConge = this.absencePeriode.filter(obj => obj.CodeTypeAbsence != undefined && !uniq[obj.CodeTypeAbsence] && (uniq[obj.CodeTypeAbsence] = true));
        }
    }

    public setClasseCongesPoses(m: any, n: any, nextMonth: any): void {
        let tuple: tupleDateClass = this.tableauDesClassesCongesPoses.filter(t => t.m == m && t.n == n && t.nextMonth == nextMonth)[0];
        if (tuple == undefined) {
            const selectMonth = (nextMonth) ? this.nextMonthMonth : this.currentMonth;
            const selectYear = (nextMonth) ? this.nextMonthYear : this.currentYear;
            const startDay = new Date(selectYear, selectMonth, 0);
            const dateCellule = this.getDateOfCellule(startDay, m, n);
            tuple = { m: m, n: n, nextMonth: nextMonth, d: dateCellule, classe: "cell-none" };
            this.tableauDesClassesCongesPoses.push(tuple);
        }
        tuple.classe = this.getCalendarClassCongesPoses(tuple.d);
    }

    public setClasseSelection(m: any, n: any, nextMonth: any): void {
        let tuple: tupleDateClass = this.tableauDesClassesSelection.filter(t => t.m == m && t.n == n && t.nextMonth == nextMonth)[0];
        if (tuple == undefined) {
            const selectMonth = (nextMonth) ? this.nextMonthMonth : this.currentMonth;
            const selectYear = (nextMonth) ? this.nextMonthYear : this.currentYear;
            const startDay = new Date(selectYear, selectMonth, 0);
            const dateCellule = this.getDateOfCellule(startDay, m, n);
            tuple = { m: m, n: n, nextMonth: nextMonth, d: dateCellule, classe: "cell-none" };
            this.tableauDesClassesSelection.push(tuple);
        }
        tuple.classe = this.getCalendarClassSelection(tuple.d, m, n, nextMonth);
    }

    public getClasseCongesPosee(m: any, n: any, nextMonth: any): string {
        const tuple: tupleDateClass = this.tableauDesClassesCongesPoses.filter(t => t.m == m && t.n == n && t.nextMonth == nextMonth)[0];
        if (tuple == undefined) {
            return "cell-none";
        }

        return tuple.classe;
    }

    public getClasseHover(m: any, n: any, nextMonth: any): string {
        const tuple: tupleDateClass = this.tableauDesClassesCongesPoses.filter(t => t.m == m && t.n == n && t.nextMonth == nextMonth)[0];
        if (tuple == undefined) {
            return "cell-none";
        }
        const get = tuple.classe.replace(/wait/g, "").trim();

        return get;
    }

    public getClasseSelection(m: any, n: any, nextMonth: any): string {
        const tuple: tupleDateClass = this.tableauDesClassesSelection.filter(t => t.m == m && t.n == n && t.nextMonth == nextMonth)[0];
        if (tuple == undefined) {
            return "cell-none";
        }

        return tuple.classe;
    }

    public isToday(m: any, n: any, nextMonth: any): boolean {
        const tuple: tupleDateClass = this.tableauDesClassesCongesPoses.filter(t => t.m == m && t.n == n && t.nextMonth == nextMonth)[0];

        // Si une absence existe, on n'affiche pas le tag qui montre le jour actuel
        if (tuple === undefined || tuple.classe.replace(/ /g, "") !== "cell-none") {
            return false;
        }

        // Si pas de jour posé, on vérifie que c'est bien le jour actuel
        const d = moment(tuple.d);
        const today = new Date();
        if (d.isSame(today, "d")) {
            return true;
        }

        return false;
    }

    public reset(): void {
        this.hideCRPCEN = false;
        this.enableCRPCEN = false;
        this.enableMotifReprise = false;
        this.isSaving = false;
        this.initMounted();
        this.dateDebut = undefined;
        this.dateFin = undefined;
        this.debutMatinAprem = "M";
        this.finMatinAprem = "A";
        this.isModeHeures = false;
        this.nombreHeures = undefined;
        this.dureeLibelleHeures = this.dureeLibelleHeuresParDefaut;
        this.isModeJours = false;
        this.nombreJours = 0;
        this.dureeLibelleJours = this.dureeLibelleJoursParDefaut;
        this.isModeMois = false;
        this.nombreMois = 0;
        this.dureeLibelleMois = this.dureeLibelleMoisParDefaut;
        this.typeConges = this.paieEnable ? "" : "JCONG";
        this.tableauDesClassesSelection = [];
        this.getOldclass = "";
        this.etatAbsence = undefined;
        this.$forceUpdate();
    }

    public remiseAZero(): void {
        this.reset();
        this.init(this.modeOuvertureAbsence, this.dateChargeePremierMoisCalendrier, this.idSalarie, this.idConge);
        this.fetchData(true);
        this.$forceUpdate();
    }

    public initMounted(): void {
        this.initAffichageMoisCalendrier();
    }

    public initAffichageMoisCalendrier(datePremierMoisCalendrier?: Date): void {
        if (ParametresInstance.societeCourante == undefined) {
            return;
        }

        if (datePremierMoisCalendrier != undefined) {
            this.currentDate = moment.utc(datePremierMoisCalendrier).toDate();
        } else if (ParametresInstance.societeCourante.PeriodeActive != undefined) {
            this.currentDate = moment(ParametresInstance.societeCourante.PeriodeActive).toDate();
        } else {
            const date = new Date();
            const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

            this.currentDate = firstDay;
        }

        this.currentMonth = this.currentDate.getUTCMonth();
        this.currentYear = this.currentDate.getUTCFullYear();

        this.currentFilterMonth = this.currentMonth;
        this.currentFilterYear = this.currentYear;

        this.nextMonthMonth = this.currentMonth + 1;
        this.nextMonthDate = new Date(Date.UTC(this.currentYear, this.nextMonthMonth, 1));
        this.nextMonthMonth = this.nextMonthDate.getUTCMonth();
        this.nextMonthYear = this.nextMonthDate.getUTCFullYear();

        this.absenceSalarieRangeDto.dateDebut = this.currentDate;
        this.absenceSalarieRangeDto.dateFin = new Date(Date.UTC(this.nextMonthYear, this.nextMonthMonth + 1, 0));
    }

    public addMonth(): void {
        this.currentDate.setMonth(this.currentMonth + 1, 1);

        this.currentMonth = this.currentDate.getMonth();
        this.currentYear = this.currentDate.getFullYear();

        this.currentFilterMonth = this.currentMonth;
        this.currentFilterYear = this.currentYear;

        this.nextMonthMonth = this.currentMonth + 1;
        this.nextMonthDate = new Date(Date.UTC(this.currentYear, this.nextMonthMonth, 1));
        this.nextMonthMonth = this.nextMonthDate.getUTCMonth();
        this.nextMonthYear = this.nextMonthDate.getUTCFullYear();

        this.oneAbsence = undefined;
        this.idSelected = 0;

        this.absenceSalarieRangeDto.dateDebut = this.currentDate;
        this.absenceSalarieRangeDto.dateFin = new Date(Date.UTC(this.nextMonthYear, this.nextMonthMonth + 1, 0));

        this.fetchData(false);
    }

    public removeMonth(): void {
        this.currentDate.setMonth(this.currentMonth - 1, 1);
        this.currentMonth = this.currentDate.getUTCMonth();
        this.currentYear = this.currentDate.getUTCFullYear();

        this.currentFilterMonth = this.currentMonth;
        this.currentFilterYear = this.currentYear;

        this.nextMonthMonth = this.currentMonth + 1;
        this.nextMonthDate = new Date(Date.UTC(this.currentYear, this.nextMonthMonth, 1));
        this.nextMonthMonth = this.nextMonthDate.getUTCMonth();
        this.nextMonthYear = this.nextMonthDate.getUTCFullYear();

        this.oneAbsence = undefined;
        this.idSelected = 0;

        this.absenceSalarieRangeDto.dateDebut = this.currentDate;
        this.absenceSalarieRangeDto.dateFin = new Date(Date.UTC(this.nextMonthYear, this.nextMonthMonth + 1, 0));

        this.fetchData(false);
    }

    private getAbsenceFromTuple(tuple: tupleDateClass, isLeft: boolean): AbsenceSalarieDto | undefined {
        const getClass = this.getClass(tuple.classe);

        const dateCellule = moment.utc(tuple.d);
        const absences = this.absencePeriode.filter(a => this.isBetween(a.DateDebut, a.DateFin, dateCellule));

        let abs;

        if (absences.length == 1) {
            abs = absences[0];
        } else if (absences.length == 2) {
            if (isLeft) {
                if (getClass == "cell-left-multi") {
                    abs = (absences[0].DebutMatinAprem == "M" && absences[0].FinMatinAprem == "M") ? absences[0] : absences[1];
                } else if (getClass == "cell-right-multi") {
                    abs = (absences[0].DebutMatinAprem == "A" && absences[0].FinMatinAprem == "A") ? absences[1] : absences[0];
                } else if (getClass == "cell-one-multi") {
                    abs = (absences[0].DebutMatinAprem == "M" && absences[0].FinMatinAprem == "M") ? absences[0] : absences[1];
                } else if (getClass == "cell-middle-multi") {
                    if (dateCellule.isBefore(absences[0].DateFin, "day") && dateCellule.isSame(absences[0].DateDebut, "day") &&
                        dateCellule.isSame(absences[1].DateFin, "day") && dateCellule.isAfter(absences[1].DateDebut, "day")) {
                        abs = absences[1];
                    } else {
                        abs = absences[0];
                    }
                }
            } else {
                if (getClass == "cell-left-multi") {
                    abs = (absences[0].DebutMatinAprem == "M" && absences[0].FinMatinAprem == "M") ? absences[1] : absences[0];
                } else if (getClass == "cell-right-multi") {
                    abs = (absences[0].DebutMatinAprem == "A" && absences[0].FinMatinAprem == "A") ? absences[0] : absences[1];
                } else if (getClass == "cell-one-multi") {
                    abs = (absences[0].DebutMatinAprem == "A" && absences[0].FinMatinAprem == "A") ? absences[0] : absences[1];
                } else if (getClass == "cell-middle-multi") {
                    if (dateCellule.isBefore(absences[0].DateFin, "day") && dateCellule.isSame(absences[0].DateDebut, "day") &&
                        dateCellule.isSame(absences[1].DateFin, "day") && dateCellule.isAfter(absences[1].DateDebut, "day")) {
                        abs = absences[0];
                    } else {
                        abs = absences[1];
                    }
                }
            }
        } else {
            abs = undefined;
        }

        return abs;
    }

    private getColor(ourLineNumber: number, ourRowNumber: number, nextMonth: boolean, ifSelect: boolean, isLeft: boolean): any {
        const tuple: tupleDateClass = this.getTuple(ourLineNumber, ourRowNumber, nextMonth, ifSelect);
        if (tuple == undefined || tuple.classe == "cell-none") {
            return {};
        }

        let color = this.backgroundColorGrey;
        const abs = this.getAbsenceFromTuple(tuple, isLeft);
        if (!ifSelect) {
            if (abs != undefined && abs.Couleur != undefined) {
                color = abs.Couleur;
            }
        } else {
            if (this.typeConges != undefined) {
                const typeAbsence = ParametresInstance.listeTypeAbsences.filter(t => t.Code == this.typeConges)[0];
                if (typeAbsence != undefined) {
                    color = this.changeColor(typeAbsence.Couleur, 100);
                } else {
                    color = this.backgroundColorGrey;
                }
            }
        }

        return color;
    }

    public getAnnulationStyle(ourLineNumber: number, ourRowNumber: number, nextMonth: boolean, ifSelect: boolean, isLeft: boolean): string {
        const tuple: tupleDateClass = this.getTuple(ourLineNumber, ourRowNumber, nextMonth, ifSelect);
        if (tuple == undefined || tuple.classe == "cell-none") {
            return "display: none;";
        }

        const abs = this.getAbsenceFromTuple(tuple, isLeft);

        if (abs == undefined) {
            return "display: none;";
        }

        const shouldDisplay = abs.Etat == EtatAbsencesEnum.EnAttenteAnnulationGestionnaire || abs.Etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1 || abs.Etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2;

        if (!shouldDisplay) {
            return "display: none;";
        }

        // debut matin
        if (isLeft && abs.DebutMatinAprem == "M" && this.areSameDates(abs.DateDebut, tuple.d)) {
            return "top: -10%; left: -10%; --fa-secondary-color:" + this.getColor(ourLineNumber, ourRowNumber, nextMonth, ifSelect, isLeft);
        }
        // debut aprem
        else if (!isLeft && abs.DebutMatinAprem == "A" && this.areSameDates(abs.DateDebut, tuple.d)) {
            return "top: 70%; left: 80%; --fa-secondary-color: " + this.getColor(ourLineNumber, ourRowNumber, nextMonth, ifSelect, isLeft);
        }

        return "display: none;";
    }

    private areSameDates(a: Date, b: Date) {
        const moment1 = moment(a).format("DD/MM/YYYY");
        const moment2 = moment(b).format("DD/MM/YYYY");

        if (moment1 != moment2) {
            return false;
        }

        return true;
    }

    public getStyleRightOrLeft(ourLineNumber: number, ourRowNumber: number, nextMonth: boolean, ifSelect: boolean, isLeft: boolean): any {
        const color = this.getColor(ourLineNumber, ourRowNumber, nextMonth, ifSelect, isLeft);

        const tuple: tupleDateClass = this.getTuple(ourLineNumber, ourRowNumber, nextMonth, ifSelect);
        if (tuple == undefined || tuple.classe == "cell-none") {
            return {};
        }
        const getClass = this.getClass(tuple.classe);

        if (isLeft) {
            return this.getBorderStyleLeft(getClass, color);
        } else {
            return this.getBorderStyleRight(getClass, color);
        }
    }

    public getStyle(ourLineNumber: number, ourRowNumber: number, nextMonth: boolean, ifSelect: boolean): any {
        const tuple: tupleDateClass = this.getTuple(ourLineNumber, ourRowNumber, nextMonth, ifSelect);
        if (tuple == undefined || tuple.classe == "cell-none") {
            return {};
        }

        const getClass = this.getClass(tuple.classe);

        const dateCellule = moment.utc(tuple.d);
        const absences = this.absencePeriode.filter(a => this.isBetween(a.DateDebut, a.DateFin, dateCellule));

        let abs;
        let absAlt;

        if (absences.length == 1) {
            abs = absences[0];
        } else if (absences.length == 2) {
            if (getClass == "cell-left-multi") {
                if (absences[0].DebutMatinAprem == "M" && absences[0].FinMatinAprem == "M") {
                    abs = absences[1];
                    absAlt = absences[0];
                } else {
                    abs = absences[0];
                    absAlt = absences[1];
                }
            } else if (getClass == "cell-right-multi") {
                if (absences[0].DebutMatinAprem == "A" && absences[0].FinMatinAprem == "A") {
                    abs = absences[0];
                    absAlt = absences[1];
                } else {
                    abs = absences[1];
                    absAlt = absences[0];
                }
            } else if (getClass == "cell-one-multi") {
                if (absences[0].DebutMatinAprem == "A" && absences[0].FinMatinAprem == "A") {
                    abs = absences[0];
                    absAlt = absences[1];
                } else {
                    abs = absences[1];
                    absAlt = absences[0];
                }
            } else if (getClass == "cell-middle-multi") {
                if (dateCellule.isBefore(absences[0].DateFin, "day") && dateCellule.isSame(absences[0].DateDebut, "day") &&
                    dateCellule.isSame(absences[1].DateFin, "day") && dateCellule.isAfter(absences[1].DateDebut, "day")) {
                    abs = absences[0];
                    absAlt = absences[1];
                } else {
                    abs = absences[1];
                    absAlt = absences[0];
                }
            }
        } else {
            abs = undefined;
            absAlt = undefined;
        }

        let color = this.backgroundColorGrey;
        let colorAlt = this.backgroundColorGrey;

        if (!ifSelect) {
            if (abs != undefined && abs.Couleur != undefined) {
                color = abs.Couleur;
            }
            if (absAlt != undefined && absAlt.Couleur != undefined) {
                colorAlt = absAlt.Couleur;
            }
        } else {
            if (this.typeConges != undefined) {
                const typeAbsence = ParametresInstance.listeTypeAbsences.filter(t => t.Code == this.typeConges)[0];
                if (typeAbsence != undefined) {
                    color = this.changeColor(typeAbsence.Couleur, 100);
                } else {
                    color = this.backgroundColorGrey;
                }
            }
        }

        switch (getClass) {
            case "cell-middle":
                return {
                    borderColor: color,
                    borderRight: "1px solid " + this.changeColor(color, -20)
                };
            case "cell-middle-multi":
                return {
                    borderTop: "1px solid " + colorAlt,
                    borderBottom: "1px solid " + color,
                    borderRight: "1px solid " + this.changeColor(color, -20)
                };
            case "cell-left":
                return {
                    borderColor: color,
                    borderRight: "1px solid " + this.changeColor(color, -20)
                };
            case "cell-right":
                return {
                    borderColor: color
                };
            case "cell-one":
                return {
                    border: "1px solid " + color
                };
            case "cell-left-demi":
                return {
                    borderColor: color,
                    borderRight: "1px solid " + this.changeColor(color, -20)
                };
            case "cell-right-demi":
                return {
                    borderColor: color
                };
            case "cell-one-demi-m":
                return {
                    border: "1px solid " + color
                };
            case "cell-one-demi-a":
                return {
                    border: "1px solid " + color
                };
            case "cell-left-multi":
                return {
                    borderTop: "1px solid " + colorAlt,
                    borderBottom: "1px solid " + color,
                    borderLeft: "1px solid " + colorAlt,
                    borderRight: "1px solid " + this.changeColor(color, -20)
                };
            case "cell-right-multi":
                return {
                    borderTop: "1px solid " + colorAlt,
                    borderBottom: "1px solid " + color,
                    borderRight: "1px solid " + color
                };
            case "cell-one-multi":
                return {
                    borderTop: "1px solid " + colorAlt,
                    borderBottom: "1px solid " + color,
                    borderLeft: "1px solid " + colorAlt,
                    borderRight: "1px solid " + color
                };
            case "cell-left-demi-multi":
                return {
                    borderTop: "1px solid " + color,
                    borderBottom: "1px solid " + color,
                    borderLeft: "1px solid " + color,
                    borderRight: "1px solid " + color
                };
            case "cell-right-demi-multi":
                return {
                    borderTop: "1px solid " + color,
                    borderBottom: "1px solid " + color,
                    borderLeft: "1px solid " + color,
                    borderRight: "1px solid " + color
                };
        }
    }

    private getTuple(ourLineNumber: number, ourRowNumber: number, nextMonth: boolean, ifSelect: boolean) {
        return (ifSelect)
            ? this.tableauDesClassesSelection.filter(t => t.m == ourLineNumber && t.n == ourRowNumber && t.nextMonth == nextMonth)[0]
            : this.tableauDesClassesCongesPoses.filter(t => t.m == ourLineNumber && t.n == ourRowNumber && t.nextMonth == nextMonth)[0];
    }

    private getClass(type: string) {
        let notreClass = type.replace(/wait/g, "").trim();
        notreClass = notreClass.replace(/ok-left/g, "").trim();
        notreClass = notreClass.replace(/ok-right/g, "").trim();

        return notreClass;
    }

    private getBorderStyleLeft(ourClass: string, color: string) {
        switch (ourClass) {
            case "cell-left-demi":
                return {
                    borderBottom: "28px solid " + color
                };
            case "cell-one-demi-m":
                return {
                    borderTop: "28px solid " + color
                };
            case "cell-left-demi-multi":
                return {
                    borderTop: "28px solid " + color
                };
            case "cell-one-multi":
                return {
                    borderTop: "28px solid " + color
                };
            case "cell-middle-multi":
                return {
                    borderTop: "28px solid " + color
                };
            case "cell-middle":
                return {
                    borderTop: "14px solid " + color
                };
            case "cell-left":
                return {
                    borderTop: "14px solid " + color
                };
            case "cell-right":
                return {
                    borderTop: "14px solid " + color
                };
            case "cell-one":
                return {
                    borderTop: "14px solid " + color
                };
            case "cell-left-multi":
                return {
                    borderTop: "28px solid " + color
                };
            case "cell-right-multi":
                return {
                    borderTop: "28px solid " + color
                };
        }
    }

    private getBorderStyleRight(ourClass: string, color: string) {
        switch (ourClass) {
            case "cell-right-demi":
                return {
                    borderTop: "28px solid " + color
                };
            case "cell-one-demi-a":
                return {
                    borderBottom: "28px solid " + color
                };
            case "cell-right-demi-multi":
                return {
                    borderBottom: "28px solid " + color
                };
            case "cell-one-multi":
                return {
                    borderBottom: "28px solid " + color
                };
            case "cell-middle-multi":
                return {
                    borderBottom: "28px solid " + color
                };
            case "cell-middle":
                return {
                    borderBottom: "14px solid " + color
                };
            case "cell-left":
                return {
                    borderBottom: "14px solid " + color
                };
            case "cell-right":
                return {
                    borderBottom: "14px solid " + color
                };
            case "cell-one":
                return {
                    borderBottom: "14px solid " + color
                };
            case "cell-left-multi":
                return {
                    borderBottom: "28px solid " + color
                };
            case "cell-right-multi":
                return {
                    borderBottom: "28px solid " + color
                };
        }
    }

    public isBetween(debut: any, fin: any, dateCellule: Moment): boolean {
        const c = dateCellule.isBetween(debut, fin, "days", "[]");

        return c;
    }

    public isSame(dateCellule: Moment, datePeriode: any): boolean {
        const c = dateCellule.isSame(datePeriode, "days");

        return c;
    }

    public fetchData(estInitialisation: boolean): void {
        this.isLoading = true;
        this.absencePeriode = [];
        this.tableauDesClassesCongesPoses = [];
        this.tableauDesClassesSelection = [];

        const commande = this.getCommande(estInitialisation);
        ServicesFactoryInstance.AbsencesService.getEnregistrementAbsence(commande, data => {
            if (estInitialisation) {
                if (this.modeOuvertureAbsence === ModeOuvertureAbsence.AbsenceCollectiveParGestionnaire) {
                    this.titreAbsence = " COLLECTIVE";
                } else if (data.SalarieIdentite != undefined) {
                    this.titreAbsence = ("- " + (data.SalarieIdentite.Nom ?? "") + " " + (data.SalarieIdentite.Prenom ?? "")).trim();
                }

                if (data.AbsenceSalarie != undefined) {
                    this.initialiseAbsenceEnCours(data.AbsenceSalarie);
                }

                this.getListTypeConges();
                this.listeJourFerie = data.ListeJoursFeries;
                this.listeJourFerie.map(d => d.Date = new Date(new Date(d.Date.toString()).setHours(0, 0, 0)));
                this.setTypeAbsenceIsModeSalarie();
            }

            if (data.ListeAbsencesSurPeriode != undefined) {
                this.initialiseListeAbsencesSurPeriode(data.ListeAbsencesSurPeriode);
            }

            this.repriseReelleChanged();
            this.initialiseCalendrier();
            this.verifyMatinAprem();

            if (data.AbsenceSalarie?.NombreJours) {
                this.nombreJours = data.AbsenceSalarie?.NombreJours;
            }

            this.isLoading = false;
        });
    }

    public initialiseAbsenceEnCours(absence: AbsenceSalarieDto): void {
        if (absence == undefined) {
            return;
        }

        this.enableCRPCEN = this.listeCodesAbsencesEligiblesCrpcen.filter(c => c === absence.CodeTypeAbsence).length > 0;
        this.codeTypeAbsence = absence.CodeTypeAbsence;

        if (absence.DateDebut != undefined) {
            this.dateDebut = moment.utc(absence.DateDebut).format("YYYY-MM-DD");
        }
        if (absence.DateFin != undefined) {
            this.dateFin = moment.utc(absence.DateFin).format("YYYY-MM-DD");
        }
        if (absence.SubrogationDebut != undefined) {
            this.subrogationDebut = moment.utc(absence.SubrogationDebut).format("YYYY-MM-DD");
        }
        if (absence.SubrogationFin != undefined) {
            this.subrogationFin = moment.utc(absence.SubrogationFin).format("YYYY-MM-DD");
        }
        if (absence.DateDernierTravaille != undefined) {
            this.dateDernierTravaille = moment.utc(absence.DateDernierTravaille).format("YYYY-MM-DD");
        }
        if (absence.DateRepriseReelle != undefined) {
            this.dateRepriseReelle = moment.utc(absence.DateRepriseReelle).format("YYYY-MM-DD");
        }

        this.debutMatinAprem = absence.DebutMatinAprem;
        this.finMatinAprem = absence.FinMatinAprem;
        this.libelleBulletin = absence.LibelleBulletin;
        this.codeTypeAbsence = absence.CodeTypeAbsence;
        this.couleur = absence.Couleur;
        this.nombreHeures = absence.NombreHeures; // Todo
        this.nombreJours = absence.NombreJours;
        this.nombreMois = absence.NombreMois; // Todo
        this.codeMotifReprises = absence.CodeMotifReprises;
        this.subrogation = absence.Subrogation;
        this.etatAbsence = absence.Etat;
        this.envoyerEMailSalarie = false;
        this.modifyTypeAbsence();
        this.modifyPeriode();
        this.$forceUpdate();
    }

    public initialiseListeAbsencesSurPeriode(absences: AbsenceSalarieDto[]): void {
        if (absences == undefined) {
            return;
        }

        for (let i = 0; i < absences.length; i++) {
            const abs = absences[i];

            if (this.absencePeriode.filter(a => a.Id == abs.Id).length == 0) {
                if (this.idConge != abs.Id) {
                    this.absencePeriode.push(abs);
                }
            }
        }
    }

    public initialiseCalendrier(): void {
        for (let m = 0; m < this.ligneNumber.length; m++) {
            for (let n = 0; n < this.rowNumber.length; n++) {
                this.setClasseCongesPoses(m, n, true);
                this.setClasseCongesPoses(m, n, false);
            }
        }
    }

    public calculerNombreJour(): void {
        if (this.isUpdating) {
            return;
        }
        if (this.dateDebut == undefined ||
            this.dateFin == undefined ||
            this.debutMatinAprem == undefined ||
            this.finMatinAprem == undefined) {
            return;
        }
        const deb = moment(this.dateDebut);
        const f = moment(this.dateFin);
        let compteurIndexe = "";
        const typeAbsence = this.listeTypeAbsences.filter(t => t.Code == this.codeTypeAbsence)[0];
        if (typeAbsence != undefined && typeAbsence.LibelleCourt != undefined) {
            const items = typeAbsence.LibelleCourt.split("/");
            if (items.length == 5) {
                compteurIndexe = items[4];
            }
        }
        if (compteurIndexe == "1") {
            this.nombreJours = 0;
            if (!this.isModeJours) {
                this.modifyTypeAbsence();

                return;
            }

            let d = moment(this.dateDebut);
            if (!((d.day() == 0 ||
                (d.day() == 6 && ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.JourneesAcquis == 25) ||
                this.listeJourFerie.filter(f => d.isSame(f.Date, "d")).length > 0))) {
                if (this.debutMatinAprem == "A") {
                    this.nombreJours -= 0.5;
                }
            }

            while (d <= f) {
                if (d.day() == 0 ||
                    (d.day() == 6 && ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.JourneesAcquis == 25) ||
                    this.listeJourFerie.filter(f => d.isSame(f.Date, "d") && f.TypeJournee == TypeJournee.JourneeEntiere).length > 0) {
                    this.nombreJours += 0;
                } else if (this.listeJourFerie.filter(f => d.isSame(f.Date, "d") && f.TypeJournee != TypeJournee.JourneeEntiere).length > 0) {
                    const jourFerie = this.listeJourFerie.filter(f => d.isSame(f.Date, "d") && f.TypeJournee != TypeJournee.JourneeEntiere)[0];
                    if (jourFerie.TypeJournee == TypeJournee.Matin) {
                        if (!d.isSame(f, "d") || this.finMatinAprem == "A") {
                            this.nombreJours += 0.5;
                        }
                    } else if (this.debutMatinAprem == "M" || !d.isSame(deb, "d")) {
                        this.nombreJours += 0.5;
                    }
                } else {
                    this.nombreJours += 1;
                }

                d = d.add("day", 1);

                if (this.nombreJours > 100) {
                    this.nombreJours = undefined;

                    return;
                }
            }

            if (!((f.day() == 0 ||
                (f.day() == 6 && ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.JourneesAcquis == 25) ||
                this.listeJourFerie.filter(fi => f.isSame(fi.Date, "d")).length > 0))) {
                if (this.finMatinAprem == "M") {
                    this.nombreJours -= 0.5;
                }
            }
        } else if (compteurIndexe == "0") {
            this.nombreJours = 0;
            if (!this.isModeJours) {
                return;
            }

            let d = moment(this.dateDebut);
            if (this.debutMatinAprem == "A") {
                this.nombreJours -= 0.5;
            }

            while (d <= f) {
                this.nombreJours++;
                d = d.add("day", 1);
            }

            if (this.finMatinAprem == "M") {
                this.nombreJours -= 0.5;
            }
        }
        this.$forceUpdate();
    }

    public init(modeOuvertureAbsence: ModeOuvertureAbsence, datePremierMoisCalendrier?: Date, idSalarie?: number, idConge?: number): void {
        this.resetAbsence();
        this.modeOuvertureAbsence = modeOuvertureAbsence;
        this.idSalarie = idSalarie;
        this.idConge = idConge;
        this.dateChargeePremierMoisCalendrier = datePremierMoisCalendrier == undefined
            ? undefined
            : moment.utc(datePremierMoisCalendrier).toDate();

        this.initAffichageMoisCalendrier(this.dateChargeePremierMoisCalendrier);

        this.fetchData(true);
    }

    public repriseReelleChanged() {
        if (this.dateRepriseReelle == "" || this.dateRepriseReelle == undefined) {
            this.enableMotifReprise = false;
            this.codeMotifReprises = undefined
        } else {
            this.enableMotifReprise = true;
        }
    }

    private setTypeAbsenceIsModeSalarie(): void {
        if (this.modeOuvertureAbsence == ModeOuvertureAbsence.AbsenceSalarieParSalarie) {
            if (this.listeTypeAbsences.length == 0) {
                this.setData();
            }
            this.listeTypeAbsences = this.listeTypeAbsences.filter(t => t.Code == "JCONG" || t.Code == "HCSS" || t.Code == "JRECU" || t.Code == "JTELE" || t.Code == "JFORM" || t.Code == "SAMTR" || t.Code == "RECSA" || t.Code == "REC35");
            this.codeTypeAbsence = "JCONG";
        }
        this.modifyTypeAbsence();
    }

    public resetAbsence(): void {
        this.codeMotifReprises = undefined;
        this.codeTypeAbsence = undefined;
        this.dateDebut = undefined;
        this.dateFin = undefined;
        this.debutMatinAprem = "M";
        this.finMatinAprem = "A";
        this.nombreHeures = undefined;
        this.nombreJours = 0;
        this.nombreMois = 0;
        this.dateDernierTravaille = "";
        this.dateRepriseReelle = "";
        this.subrogation = false;
        this.subrogationDebut = "";
        this.subrogationFin = "";
        this.libelleBulletin = "";
        this.envoyerEMailSalarie = false;
        this.idSalarie = undefined;
        this.idConge = undefined;
        this.dateChargeePremierMoisCalendrier = undefined;
        this.tableauDesClassesSelection = [];
        this.tableauDesClassesCongesPoses = [];
        this.$forceUpdate();
    }

    /** récupére la date de la cellule **/
    public getDateOfCellule(startDay: Date, ligne: number, colonne: number): Date {
        const dayOfFirstDayInMonth = startDay.getDay();
        const dayValue = ligne * 7 - dayOfFirstDayInMonth + colonne + 1;
        startDay.setDate(startDay.getDate() + dayValue);

        return startDay;
    }

    /** Retourne la valeur du jour des cellules du calendrier **/
    public getDayVisibleCurrentMonth(ligne: number, colonne: number, afterMonth: boolean): boolean {
        const firstDay = new Date(afterMonth ? this.nextMonthYear : this.currentYear, afterMonth ? this.nextMonthMonth : this.currentMonth, 0);
        const mois = this.getDateOfCellule(firstDay, ligne, colonne).getMonth();

        return ((mois == this.currentMonth && !afterMonth) || (mois == this.nextMonthMonth && afterMonth));
    }

    /** Retourne la valeur du jour des cellules du calendrier **/
    public getCalendarDayValueCurrentMonth(ligne: number, colonne: number): number {
        const firstDay = new Date(this.currentYear, this.currentMonth, 0);

        return this.getCalendarDayValue(firstDay, ligne, colonne);
    }

    public getCalendarDayValueNextMonth(ligne: number, colonne: number): number {
        const firstDay = new Date(this.nextMonthYear, this.nextMonthMonth, 0);

        return this.getCalendarDayValue(firstDay, ligne, colonne);
    }

    public getCalendarDayValue(startDay: Date, ligne: number, colonne: number): number {
        return this.getDateOfCellule(startDay, ligne, colonne).getDate();
    }

    public getCalendarClassCongesPoses(date: Date): string {
        const dateCellule = moment.utc(date);
        const absences = this.absencePeriode.filter(a => dateCellule.isSameOrAfter(a.DateDebut, "day") && dateCellule.isSameOrBefore(a.DateFin, "day"));

        if (absences.length == 0) {
            return " cell-none ";
        } else if (absences.length == 1) {
            const absence = absences[0];
            const isWait = this.isAbsenceEnAttente(absence) ? " wait " : "";

            if (dateCellule.isBefore(absence.DateFin, "day") && dateCellule.isAfter(absence.DateDebut, "day")) {
                return " cell-middle " + isWait;
            }

            if (dateCellule.isSame(absence.DateDebut, "day") && dateCellule.isSame(absence.DateFin, "day")) {
                return absence.DebutMatinAprem == "A" ? " cell-one-demi-a " + isWait : (absence.FinMatinAprem == "M" ? " cell-one-demi-m " + isWait : " cell-one " + isWait);
            }

            if (dateCellule.isSame(absence.DateDebut, "day") && dateCellule.isBefore(absence.DateFin, "day")) {
                return absence.DebutMatinAprem == "A" ? " cell-left-demi " + isWait : " cell-left " + isWait;
            }

            if (dateCellule.isSame(absence.DateFin, "day") && dateCellule.isAfter(absence.DateDebut, "day")) {
                return absence.FinMatinAprem == "M" ? " cell-right-demi " + isWait : " cell-right " + isWait;
            }
        } else if (absences.length == 2) {
            let getClass = "";
            let isWait = "";

            // ------------------------- CLASS

            if (dateCellule.isBefore(absences[0].DateFin, "day") && dateCellule.isSame(absences[0].DateDebut, "day") &&
                dateCellule.isSame(absences[1].DateFin, "day") && dateCellule.isAfter(absences[1].DateDebut, "day") ||
                dateCellule.isBefore(absences[1].DateFin, "day") && dateCellule.isSame(absences[1].DateDebut, "day") &&
                dateCellule.isSame(absences[0].DateFin, "day") && dateCellule.isAfter(absences[0].DateDebut, "day")) {
                getClass = " cell-middle-multi ";
            } else if (dateCellule.isSame(absences[0].DateFin, "day") && dateCellule.isAfter(absences[0].DateDebut, "day") ||
                dateCellule.isSame(absences[1].DateFin, "day") && dateCellule.isAfter(absences[1].DateDebut, "day")) {
                getClass = " cell-right-multi ";
            } else if (dateCellule.isSame(absences[0].DateDebut, "day") && dateCellule.isSame(absences[0].DateFin, "day") &&
                dateCellule.isSame(absences[1].DateDebut, "day") && dateCellule.isSame(absences[1].DateFin, "day")) {
                getClass = " cell-one-multi ";
            } else if (dateCellule.isBefore(absences[0].DateFin, "day") && dateCellule.isAfter(absences[0].DateDebut, "day") &&
                dateCellule.isBefore(absences[1].DateFin, "day") && dateCellule.isAfter(absences[1].DateDebut, "day")) {
                getClass = " cell-middle-multi ";
            } else if (dateCellule.isSame(absences[0].DateDebut, "day") && dateCellule.isBefore(absences[0].DateFin, "day") ||
                dateCellule.isSame(absences[1].DateDebut, "day") && dateCellule.isBefore(absences[1].DateFin, "day")) {
                getClass = " cell-left-multi ";
            }

            // ------------------------- ORDER

            let absenceMatin = absences[0];
            let absenceSoir = absences[1];

            if (getClass == " cell-left-multi " || getClass == " cell-one-multi ") {
                if (absences[0].DebutMatinAprem == "M" && absences[0].FinMatinAprem == "M") {
                    absenceMatin = absences[0];
                    absenceSoir = absences[1];
                } else {
                    absenceMatin = absences[1];
                    absenceSoir = absences[0];
                }
            } else if (getClass == " cell-right-multi ") {
                if (absences[0].DebutMatinAprem == "A" && absences[0].FinMatinAprem == "A") {
                    absenceMatin = absences[1];
                    absenceSoir = absences[0];
                } else {
                    absenceMatin = absences[0];
                    absenceSoir = absences[1];
                }
            } else if (getClass == " cell-middle-multi ") {
                if (dateCellule.isBefore(absences[0].DateFin, "day") && dateCellule.isSame(absences[0].DateDebut, "day") &&
                    dateCellule.isSame(absences[1].DateFin, "day") && dateCellule.isAfter(absences[1].DateDebut, "day")) {
                    absenceMatin = absences[1];
                    absenceSoir = absences[0];
                } else {
                    absenceMatin = absences[0];
                    absenceSoir = absences[1];
                }
            }

            // ------------------------- WAIT

            const matinEnAttenteValidation = this.isAbsenceEnAttente(absenceMatin);

            const matinValide = absenceMatin.Etat == EtatAbsencesEnum.Valide ||
                absenceMatin.Etat == EtatAbsencesEnum.Calcule ||
                absenceMatin.Etat == EtatAbsencesEnum.Cloture;

            const soirEnAttenteValidation = this.isAbsenceEnAttente(absenceSoir);

            const soirValide = absenceSoir.Etat == EtatAbsencesEnum.Valide ||
                absenceSoir.Etat == EtatAbsencesEnum.Calcule ||
                absenceSoir.Etat == EtatAbsencesEnum.Cloture;

            if (matinEnAttenteValidation && soirEnAttenteValidation) {
                isWait = " wait ";
            } else if (matinValide && soirEnAttenteValidation) {
                isWait = " wait ok-left ";
            } else if (matinEnAttenteValidation && soirValide) {
                isWait = " wait ok-right ";
            }

            // ------------------------- RETURN

            return getClass + isWait;
        }

        return "";
    }

    private isAbsenceEnAttente(absence: AbsenceSalarieDto): boolean {
        return (absence.Etat == EtatAbsencesEnum.EnAttenteValidationGestionnaire ||
            absence.Etat == EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1 ||
            absence.Etat == EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2 ||
            absence.Etat == EtatAbsencesEnum.EnAttenteAnnulationGestionnaire ||
            absence.Etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1 ||
            absence.Etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2);
    }

    public getClassColorNumber(m: any, n: any, nextMonth: any): string {
        const tuple: tupleDateClass = this.tableauDesClassesCongesPoses.filter(t => t.m == m && t.n == n && t.nextMonth == nextMonth)[0];

        let classCss = (this.listeJourFerie.filter(j => j.Date.getTime() == tuple.d.getTime()).length > 0) ? "number-holiday" : "";

        if (this.isToday(m, n, nextMonth)) {
            classCss += " number-today";
        }

        return classCss;
    }

    public getCalendarClassSelection(date: Date, m: any, n: any, nextMonth: any): string {
        if (this.dateDebut == undefined && this.dateFin == undefined) {
            return "cell-none";
        }

        const dateCellule = moment(date);
        const get = this.getClasseHover(m, n, nextMonth);

        if (this.dateDebut != undefined && this.dateFin == undefined) {
            if (dateCellule.isSame(this.dateDebut, "day")) {
                return "cell-left";
            }
        }

        if (this.dateDebut != undefined && this.dateFin != undefined) {
            if (dateCellule.isBefore(this.dateDebut, "day")) {
                return "cell-none";
            }

            if (dateCellule.isAfter(this.dateFin, "day")) {
                return "cell-none";
            }

            if (dateCellule.isAfter(this.dateDebut, "day") && dateCellule.isBefore(this.dateFin, "day")) {
                return "cell-middle";
            }

            if (dateCellule.isSame(this.dateDebut, "day") && dateCellule.isSame(this.dateFin, "day")) {
                if (get == "cell-left-demi") {
                    return "cell-left-demi-multi";
                } else if (get == "cell-right-demi") {
                    return "cell-right-demi-multi";
                }

                return this.debutMatinAprem == "A" ? "cell-one-demi-a" : (this.finMatinAprem == "M" ? "cell-one-demi-m" : "cell-one");
            }

            if (dateCellule.isSame(this.dateDebut, "day")) {
                return this.debutMatinAprem == "A" ? "cell-left-demi" : "cell-left";
            }

            if (dateCellule.isSame(this.dateFin, "day")) {
                return this.finMatinAprem == "M" ? "cell-right-demi" : "cell-right";
            }
        }

        return " cell-none ";
    }

    public modifyTypeAbsence(): void {
        const c = this.listeTypeAbsences.filter(c => c.Code == this.codeTypeAbsence);
        this.enableDateDernierJourTravaille = false;
        if (c != undefined && c.length > 0) {
            const type = c[0];
            this.couleur = type.Couleur;
            this.enableDateDernierJourTravaille = type.Code == "JCMAT" || type.Code == "JCPAT" || type.Code == "JMALA" || type.Code == "JMAAC" ||
                type.Code == "TPTHA" || type.Code == "TPTHP" || type.Code == "TPTH" || type.Code == "TPTHT" ||
                type.Code == "JCMAP" || type.Code == "JCACT" || type.Code == "JMALS";
            this.hideCRPCEN = type.Code == "JCMAT" || type.Code == "JCPAT" || type.Code == "JMALA" || type.Code == "JMALS";
            this.libelleBulletin = type.Complement;
            if (type.LibelleCourt != undefined) {
                const elements = type.LibelleCourt.split("/");

                let libelleRubrique = this.GetLibelleRubrique(elements[1]);
                if (libelleRubrique == undefined) {
                    this.dureeLibelleHeures = this.dureeLibelleHeuresParDefaut;
                    this.isModeHeures = false;
                    this.nombreHeures = undefined;
                } else {
                    this.dureeLibelleHeures = libelleRubrique;
                    this.isModeHeures = true;
                }
                if (!this.isModeHeures) {
                    this.nombreHeures = undefined;
                }

                libelleRubrique = this.GetLibelleRubrique(elements[2]);
                if (libelleRubrique == undefined) {
                    this.dureeLibelleJours = this.dureeLibelleJoursParDefaut;
                    this.isModeJours = false;
                    this.nombreJours = 0;
                } else {
                    this.dureeLibelleJours = libelleRubrique;
                    this.isModeJours = true;
                    this.calculerNombreJour();
                }

                libelleRubrique = this.GetLibelleRubrique(elements[3]);
                if (libelleRubrique == undefined) {
                    this.dureeLibelleMois = this.dureeLibelleMoisParDefaut;
                    this.isModeMois = false;
                    this.nombreMois = 0;
                } else {
                    this.dureeLibelleMois = libelleRubrique;
                    this.isModeMois = true;
                }
                if (!this.isModeMois) {
                    this.nombreMois = 0;
                }
            }

            this.isReadOnlyJours = this.modeOuvertureAbsence === ModeOuvertureAbsence.AbsenceSalarieParSalarie || this.codeTypeAbsence != "HCSS";
            this.isReadOnlyJours = this.modeOuvertureAbsence === ModeOuvertureAbsence.AbsenceSalarieParSalarie;
            this.isReadOnlyMois = this.modeOuvertureAbsence === ModeOuvertureAbsence.AbsenceSalarieParSalarie;
        }
    }

    public GetLibelleRubrique(codeRubrique: string): string | undefined {
        let libelle: string | undefined;

        const listeRubriquesFiltrees = ParametresInstance.listeRubriques.filter(r => r.CodeRubrique == codeRubrique && r.CodeNature == "A");
        if (listeRubriquesFiltrees.length > 0) {
            libelle = listeRubriquesFiltrees[0].LibelleRubrique;
        }

        return libelle;
    }

    public detail(absence: AbsenceSalarieDto): void {
        this.oneAbsence = absence;
        this.idSelected = absence.Id != undefined ? absence.Id : 0;
        this.$forceUpdate();
    }

    public generationCRPCEN(): void {
        if (this.idConge === undefined) {
            NotificationServiceInstance.SendFailed("L'absence pour laquelle le document CRPCEN a été demandé n'a pas pu être identifiée");
        } else {
            ServicesFactoryInstance.AbsencesService.getAbsence(this.idConge, (data) => {
                this.$emit("generationCRPCEN", data);
                this.cancel();
            });
        }
    }

    public cancel(): void {
        $("#modalAjouterAbsence").modal("hide");
        this.resetAbsence();
        this.reset();
    }

    public save(): void {
        if (this.isSaving) {
            return;
        }

        this.isSaving = true;

        // Contrôle champ "date du jour précédent l'arrêt en saisie d'absence maladie, maternité et accident du travail est supérieure à la date de début de l'arrêt de travail
        if (this.enableDateDernierJourTravaille) {
            if (moment.utc(this.dateDernierTravaille).toDate() >= moment.utc(this.dateDebut).toDate()) {
                NotificationServiceInstance.SendFailed("La date du jour précédent l'arrêt doit être inférieure à la date de début de l'arrêt");

                this.isSaving = false;

                return;
            }

            if (moment.utc(this.dateFin).toDate() >= moment.utc(this.dateRepriseReelle).toDate()) {
                NotificationServiceInstance.SendFailed("La date de reprise réelle doit être supérieure à la date de fin d'arrêt");

                this.isSaving = false;

                return;
            }

            // Vérification du motif de reprise
            if (this.dateRepriseReelle != undefined && this.dateRepriseReelle != ""
                && (this.codeMotifReprises == undefined || this.codeMotifReprises == "")) {
                NotificationServiceInstance.SendFailed("Le motif de reprise doit être renseigné si la date de reprise réelle l'est.");

                this.isSaving = false;
                return;
            }
        } else {
            this.dateDernierTravaille = undefined;
            this.dateRepriseReelle = undefined;
            this.codeMotifReprises = undefined;
        }

        if (!this.isModeHeures && !this.isModeJours && !this.isModeMois) {
            NotificationServiceInstance.SendFailed("Le congé doit être associé à un mode de durée en heures, jours, ou mois.");
            this.isSaving = false;

            return;
        }

        let uneValeurSelectionnee = false;
        if (this.isModeHeures && this.nombreHeures != undefined && this.nombreHeures > 0) {
            uneValeurSelectionnee = true;
        }
        if (!uneValeurSelectionnee && this.isModeJours && this.nombreJours != undefined && this.nombreJours > 0) {
            uneValeurSelectionnee = true;
        }
        if (!uneValeurSelectionnee && this.isModeMois && this.nombreMois != undefined && this.nombreMois > 0) {
            uneValeurSelectionnee = true;
        }

        if (!uneValeurSelectionnee) {
            this.isSaving = false;
            NotificationServiceInstance.SendFailed("Une valeur de durée doit être renseignée.");

            return;
        }

        if (this.subrogation
            && this.subrogationDebut != undefined
            && this.subrogationFin != undefined
            && this.subrogationDebut > this.subrogationFin) {
            NotificationServiceInstance.SendFailed("La date de début de subrogation doit être inférieure ou égale à celle de fin.");
            this.isSaving = false;

            return;
        }

        if (this.subrogation
            && this.subrogationDebut != undefined
            && this.dateDebut != undefined
            && this.subrogationDebut < this.dateDebut) {
            NotificationServiceInstance.SendFailed("La date de début de subrogation doit être supérieure ou égale à la date de début de l'arrêt.");
            this.isSaving = false;

            return;
        }

        const absenceAEnregistrer = this.getAbsenceSalarie();
        if (this.modeOuvertureAbsence === ModeOuvertureAbsence.AbsenceSalarieParSalarie || this.modeOuvertureAbsence === ModeOuvertureAbsence.AbsenceSalarieParGestionnaire) {
            ServicesFactoryInstance.AbsencesService.enregistrerAbsence(absenceAEnregistrer, this.isActionSalarie, this.envoyerEMailSalarie, data => {

                NotificationServiceInstance.SendSuccess(`La demande d'absence a été enregistrée.`);

                this.$emit("enregistrerAbsenceOk", data);
                this.cancel();
            }, () => this.isSaving = false);
        } else {
            this.cancel();
            this.$emit("enregistrementAbsenceCollectiveOk", absenceAEnregistrer);
        }
    }

    public onDateClicked(m: number, n: number, nextMonth: boolean): void {
        const tuple: tupleDateClass = this.tableauDesClassesCongesPoses.filter(t => t.m == m && t.n == n && t.nextMonth == nextMonth)[0];
        const dateCellule = moment(tuple.d);

        if (tuple == undefined) {
            return;
        }

        const type = tuple.classe;
        let get = type.replace("wait", "").trim();
        get = get.replace("ok-left", "").trim();
        get = get.replace("ok-right", "").trim();

        if (get != "cell-none" &&
            get != "cell-one-demi-m" &&
            get != "cell-one-demi-a" &&
            get != "cell-left-demi" &&
            get != "cell-right-demi") {
            return;
        }

        const date = tuple.d;
        const dateMonth = date.getMonth();

        if (nextMonth) {
            if (dateMonth != this.nextMonthMonth) {
                return;
            }
        } else {
            if (dateMonth != this.currentMonth) {
                return;
            }
        }

        // -----------------

        if (this.nouvelleSaisie) {
            this.getOldclass = get;
            this.dateDebut = dateCellule.format("YYYY-MM-DD");
            this.debutMatinAprem = "M";
            this.finMatinAprem = "A";
            this.dateFin = "";
            this.enableSelectDebutMatinAprem = true;
            this.enableSelectFinMatinAprem = true;
            this.enableInputDebutMatinAprem = true;
            this.enableInputFinMatinAprem = true;

            if (get == "cell-one-demi-m") {
                this.debutMatinAprem = "A";
                this.finMatinAprem = "A";
                this.nouvelleSaisie = false;
                this.enableSelectDebutMatinAprem = false;
            } else if (get == "cell-one-demi-a" || get == "cell-left-demi") {
                this.debutMatinAprem = "M";
                this.finMatinAprem = "M";
                this.dateFin = dateCellule.format("YYYY-MM-DD");
                this.nouvelleSaisie = true;
                this.enableSelectDebutMatinAprem = false;
                this.enableSelectFinMatinAprem = false;
                this.enableInputFinMatinAprem = false;
            } else if (get == "cell-right-demi") {
                this.debutMatinAprem = "A";
                this.nouvelleSaisie = false;
                this.enableSelectDebutMatinAprem = false;
            } else {
                this.debutMatinAprem = "M";
                this.finMatinAprem = "A";
                this.nouvelleSaisie = false;
            }
        } else {
            if (moment(dateCellule).isAfter(moment(this.dateDebut))) {
                if (this.absencePeriode.filter(a => moment(a.DateDebut).isAfter(moment(this.dateDebut)) && moment(a.DateFin).isBefore(moment(dateCellule))).length > 0) {
                    if (get == "cell-one-demi-a") {
                        this.dateDebut = dateCellule.format("YYYY-MM-DD");
                        this.dateFin = dateCellule.format("YYYY-MM-DD");
                        this.nouvelleSaisie = true;
                        this.debutMatinAprem = "M";
                        this.finMatinAprem = "M";
                        this.enableSelectDebutMatinAprem = false;
                        this.enableSelectFinMatinAprem = false;
                        this.enableInputFinMatinAprem = false;
                    } else if (get == "cell-left-demi") {
                        this.dateDebut = dateCellule.format("YYYY-MM-DD");
                        this.dateFin = dateCellule.format("YYYY-MM-DD");
                        this.nouvelleSaisie = true;
                        this.debutMatinAprem = "M";
                        this.finMatinAprem = "M";
                    } else if (get == "cell-right-demi") {
                        this.dateDebut = dateCellule.format("YYYY-MM-DD");
                        this.dateFin = "";
                        this.nouvelleSaisie = false;
                        this.debutMatinAprem = "A";
                    } else {
                        this.resetSelection(dateCellule, get);
                    }
                } else if (get == "cell-one-demi-a") {
                    this.dateFin = dateCellule.format("YYYY-MM-DD");
                    this.nouvelleSaisie = true;
                    this.finMatinAprem = "M";
                    this.enableSelectFinMatinAprem = false;
                    this.enableInputFinMatinAprem = false;
                    // this.debutMatinAprem = (this.getOldclass == "cell-right-demi" || this.getOldclass == "cell-one-demi-m") ? "A" : "M";
                } else if (get == "cell-left-demi") {
                    this.finMatinAprem = "M";
                    this.nouvelleSaisie = true;
                    this.dateFin = dateCellule.format("YYYY-MM-DD");
                    this.enableSelectFinMatinAprem = false;
                    this.enableInputFinMatinAprem = false;
                } else if (get == "cell-right-demi") {
                    this.dateDebut = dateCellule.format("YYYY-MM-DD");
                    this.dateFin = "";
                    this.debutMatinAprem = "A";
                    this.finMatinAprem = "A";
                    this.enableSelectDebutMatinAprem = false;
                    this.nouvelleSaisie = false;
                } else if (get == "cell-one-demi-m") {
                    this.dateDebut = dateCellule.format("YYYY-MM-DD");
                    this.dateFin = "";
                    this.debutMatinAprem = "A";
                    this.finMatinAprem = "A";
                    this.enableSelectDebutMatinAprem = false;
                    this.nouvelleSaisie = false;
                } else {
                    if (this.absencePeriode.filter(a => moment(a.DateDebut).isAfter(moment(this.dateDebut)) && moment(a.DateFin).isBefore(moment(dateCellule))).length > 0) {
                        this.dateDebut = dateCellule.format("YYYY-MM-DD");
                        this.dateFin = "";
                        this.nouvelleSaisie = true;
                    } else {
                        this.dateFin = dateCellule.format("YYYY-MM-DD");
                        this.nouvelleSaisie = true;
                    }
                }
            } else if (moment(dateCellule).isSame(moment(this.dateDebut))) {
                this.dateFin = dateCellule.format("YYYY-MM-DD");
                this.nouvelleSaisie = true;

                if (get != "cell-none") {
                    this.enableSelectFinMatinAprem = false;
                    this.enableInputFinMatinAprem = false;
                }
            } else {
                if (get == "cell-one-demi-a") {
                    this.dateDebut = dateCellule.format("YYYY-MM-DD");
                    this.dateFin = dateCellule.format("YYYY-MM-DD");
                    this.nouvelleSaisie = true;
                    this.debutMatinAprem = "M";
                    this.finMatinAprem = "M";
                } else if (get == "cell-right-demi") {
                    this.debutMatinAprem = "A";
                    this.dateDebut = dateCellule.format("YYYY-MM-DD");
                    this.dateFin = "";
                    this.nouvelleSaisie = false;
                } else if (get == "cell-left-demi") {
                    this.debutMatinAprem = "M";
                    this.finMatinAprem = "M";
                    this.dateDebut = dateCellule.format("YYYY-MM-DD");
                    this.dateFin = dateCellule.format("YYYY-MM-DD");
                    this.nouvelleSaisie = true;
                    this.enableSelectDebutMatinAprem = false;
                    this.enableInputDebutMatinAprem = false;
                    this.enableSelectFinMatinAprem = false;
                    this.enableInputFinMatinAprem = false;
                } else {
                    this.resetSelection(dateCellule, get);
                }
            }
        }

        this.dateChanged();
        this.enableSelectMatinAprem(get);
    }

    private resetSelection(dateCellule: moment.Moment, get: string): void {
        this.dateDebut = dateCellule.format("YYYY-MM-DD");
        this.dateFin = "";
        this.enableSelectDebutMatinAprem = true;
        this.enableSelectFinMatinAprem = true;
        this.enableInputDebutMatinAprem = true;
        this.enableInputFinMatinAprem = true;

        switch (get) {
            case "cell-one-demi-m":
                this.debutMatinAprem = "A";
                break;
            case "cell-one-demi-a":
                this.debutMatinAprem = "M";
                break;
            case "cell-right-demi":
                this.debutMatinAprem = "A";
                break;
            case "cell-left-demi":
                this.finMatinAprem = "M";
                break;
            default:
                this.debutMatinAprem = "M";
                break;
        }
    }

    private enableSelectMatinAprem(get: string): void {
        this.enableDebutMatinApremM = true;
        this.enableDebutMatinApremA = true;
        this.enableFinMatinApremM = true;
        this.enableFinMatinApremA = true;

        if (!this.nouvelleSaisie) {
            switch (get) {
                case "cell-one-demi-a":
                    this.enableDebutMatinApremA = false;
                    this.enableFinMatinApremA = false;
                    break;
                case "cell-one-demi-m":
                    this.enableDebutMatinApremM = false;
                    break;
                case "cell-right-demi":
                    this.enableDebutMatinApremM = false;
                    break;
            }
        } else {
            if (this.dateDebut == this.dateFin) {
                switch (get) {
                    case "cell-one-demi-a":
                        this.enableDebutMatinApremA = false;
                        this.enableFinMatinApremA = false;
                        break;
                    case "cell-left-demi":
                        this.enableDebutMatinApremA = false;
                        this.enableFinMatinApremA = false;
                        break;
                    case "cell-one-demi-m":
                        this.enableDebutMatinApremM = false;
                        this.enableFinMatinApremM = false;
                        break;
                    case "cell-right-demi":
                        this.enableDebutMatinApremM = false;
                        this.enableFinMatinApremM = false;
                        break;
                }
            } else {
                const periodesChevauchement = this.absencePeriode.filter(a => this.isBetween(a.DateDebut, a.DateFin, moment(this.dateDebut)));
                // if (this.absencePeriode.filter(a => this.isBetween(a.DateDebut, a.DateFin, moment.utc(this.dateDebut))).length > 0) {
                if (periodesChevauchement.length > 0) {
                    if (periodesChevauchement.filter(a => this.isSame(moment(this.dateDebut), a.DateFin)).length > 0) {
                        this.enableDebutMatinApremM = false;
                    }
                    if (periodesChevauchement.filter(a => this.isSame(moment(this.dateFin), a.DateFin)).length > 0) {
                        this.enableDebutMatinApremA = false;
                    }

                    if (get == "cell-one-demi-a") {
                        this.enableFinMatinApremA = false;
                    }
                } else {
                    if (get == "cell-left-demi") {
                        this.enableFinMatinApremA = false;
                    }
                }
            }
        }

        this.$forceUpdate();
    }

    private dateChanged(): void {
        this.verifyMatinAprem();

        // On set date dernier jour travaillé si il est visible
        if (this.enableDateDernierJourTravaille && !this.estModeSalarie()) {
            let dateJourPrecedentArret = moment.utc(this.dateDebut);
            dateJourPrecedentArret = dateJourPrecedentArret.subtract(1, "days");
            this.dateDernierTravaille = dateJourPrecedentArret.format("YYYY-MM-DD");
        } else {
            this.dateDernierTravaille = undefined;
        }
    }

    private verifyMatinAprem(): void {
        this.enableFinMatinApremM = !((this.dateDebut == this.dateFin && this.debutMatinAprem == "A"));

        if (this.dateDebut == this.dateFin) {
            if (this.debutMatinAprem == "A" && this.finMatinAprem == "M") {
                this.finMatinAprem = "A";
            }
        }
        this.tableauDesClassesSelection = [];
        for (let i = 0; i < this.ligneNumber.length; i++) {
            for (let j = 0; j < this.rowNumber.length; j++) {
                this.setClasseSelection(i, j, true);
                this.setClasseSelection(i, j, false);
            }
        }
        this.calculerNombreJour();
        this.$forceUpdate();
    }

    public changeColor(color: any, val: any): string {
        let usePound = false;

        if (color[0] == "#") {
            color = color.slice(1);
            usePound = true;
        }

        const num = parseInt(color, 16);

        let r = (num >> 16) + val;

        if (r > 255) {
            r = 255;
        } else if (r < 0) {
            r = 0;
        }

        let b = ((num >> 8) & 0x00FF) + val;

        if (b > 255) {
            b = 255;
        } else if (b < 0) {
            b = 0;
        }

        let g = (num & 0x0000FF) + val;

        if (g > 255) {
            g = 255;
        } else if (g < 0) {
            g = 0;
        }

        return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    }

    public refresh(): void {
        this.$forceUpdate();
    }

    public modifyPeriode(): void {
        if (this.isModeJours) {
            this.calculerNombreJour();
        }

        if (this.dateDebut != undefined) {
            this.minEndDate = moment.utc(this.dateDebut).format("YYYY-MM-DD");
        }
    }

    public getAbsenceSalarie(): AbsenceSalarieDto {
        return {
            Id: this.idConge,
            CodeSociete: ParametresInstance?.societeCourante?.Code,
            IdSalarie: this.idSalarie ?? 0,
            DateDebut: moment.utc(this.dateDebut).toDate(),
            DateFin: moment.utc(this.dateFin).toDate(),
            DebutMatinAprem: this.debutMatinAprem,
            FinMatinAprem: this.finMatinAprem,
            LibelleBulletin: this.libelleBulletin,
            CodeTypeAbsence: this.codeTypeAbsence,
            Couleur: this.couleur,
            NombreHeures: this.nombreHeures,
            NombreJours: this.nombreJours,
            NombreMois: this.nombreMois,
            CodeMotifReprises: this.codeMotifReprises,
            DateDernierTravaille: this.dateDernierTravaille == undefined ? undefined : moment.utc(this.dateDernierTravaille).toDate(),
            DateRepriseReelle: this.dateRepriseReelle == undefined ? undefined : moment.utc(this.dateRepriseReelle).toDate(),
            Subrogation: this.subrogation,
            SubrogationDebut: moment.utc(this.subrogationDebut).toDate(),
            SubrogationFin: moment.utc(this.subrogationFin).toDate(),
            Etat: this.etatAbsence != undefined ? this.etatAbsence : this.modeOuvertureAbsence === ModeOuvertureAbsence.AbsenceSalarieParSalarie ? EtatAbsencesEnum.EnAttenteValidationGestionnaire : EtatAbsencesEnum.Valide,
            Imposee: this.modeOuvertureAbsence === ModeOuvertureAbsence.AbsenceCollectiveParGestionnaire
        };
    }

    public getCommande(estInitialisation: boolean): CommandeEnregistrementAbsenceDto {
        return {
            IdSalarie: this.idSalarie,
            CodeSociete: ParametresInstance?.societeCourante?.Code,
            IdAbsence: this.idConge,
            DateDebut: new Date(Date.UTC(this.absenceSalarieRangeDto.dateDebut.getUTCFullYear(), this.absenceSalarieRangeDto.dateDebut.getUTCMonth(), 1)),
            DateFin: this.absenceSalarieRangeDto.dateFin,
            EstInitialisation: estInitialisation
        };
    }

    public estModeSalarie(): boolean {
        return this.modeOuvertureAbsence === ModeOuvertureAbsence.AbsenceSalarieParSalarie;
    }

    public estModeGestionaire(): boolean {
        return this.modeOuvertureAbsence === ModeOuvertureAbsence.AbsenceSalarieParGestionnaire;
    }

    public toggleSubrogation(): void {
        this.subrogation = !this.subrogation;
    }

    public toggleEnvoiEMail(): void {
        this.envoyerEMailSalarie = !this.envoyerEMailSalarie;
    }

    public isDatePickerVisible = false;
    public showDateSelector(): void {
        this.isDatePickerVisible = true;
    }

    public selectedYear(year: number): void {
        this.currentDate.setFullYear(year);
        this.currentYear = this.currentDate.getFullYear();

        this.currentFilterMonth = this.currentMonth;
        this.currentFilterYear = this.currentYear;

        this.nextMonthMonth = this.currentMonth + 1;
        this.nextMonthDate = new Date(Date.UTC(this.currentYear, this.nextMonthMonth, 1));
        this.nextMonthMonth = this.nextMonthDate.getMonth();
        this.nextMonthYear = this.nextMonthDate.getFullYear();

        this.oneAbsence = undefined;
        this.idSelected = 0;

        this.absenceSalarieRangeDto.dateDebut = this.currentDate;
        this.absenceSalarieRangeDto.dateFin = new Date(this.nextMonthYear, this.nextMonthMonth + 1, 0);

        this.fetchData(false);

        this.closeDatePicker();
    }

    public closeDatePicker(): void {
        this.isDatePickerVisible = false;
    }
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/modals/modalAjouterAbsence/modalAjouterAbsence.ts